import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
import { VEHICLE_MODEL_AI_RECOGNITION_TYPES, } from './vehicle.js';
export const genericAiTextRecognitionTypeEnum = createEnum({
    CONTENT_TRANSLATION: ['content_translation', '通用内容翻译'],
});
export const GENERIC_AI_TEXT_RECOGNITION_TYPES = enumValues(genericAiTextRecognitionTypeEnum);
export const GENERIC_AI_TEXT_RECOGNITION_TYPE_LABEL_MAP = enumLabelMap(genericAiTextRecognitionTypeEnum);
export const AI_TEXT_RECOGNITION_TYPES = [
    ...VEHICLE_MODEL_AI_RECOGNITION_TYPES,
    ...GENERIC_AI_TEXT_RECOGNITION_TYPES,
];
//# sourceMappingURL=ai.js.map